import React from "react";
import styles from "./ContactBox.module.css";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhoneFlip } from "@fortawesome/free-solid-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";

const ContactBox = () => {
  return (
    <div className="container">
      <div className="row">
        <div className="col" id={styles.col}>
          <div className={styles.spacing}>
            <h2 id={styles.h2}>Need technical help?</h2>
            <div className={styles.p}>
              <div className="d-inline block">
                <FontAwesomeIcon icon={faPhoneFlip} className={styles.icon} />
                <span className={styles.header}>CALL US</span>
                <br />
                <Link className={styles.link} to="tel:18009184980">
                  1-800-918-4980
                </Link>
              </div>
            </div>
            <div className={styles.p}>
              <div className="d-inline block" id={styles.text}>
                <FontAwesomeIcon icon={faEnvelope} className={styles.icon} />
                <span className={styles.header}>EMAIL US</span>
                <br />
                <span className={styles.small}>SELECT YOUR AIRLING</span>
                <br />
                <Link className={styles.link} to="mailto:tech+as@bidpro.com">
                  Alaska
                </Link>
                <br />
                <Link className={styles.link} to="mailto:tech+aa@bidpro.com">
                  American
                </Link>
                <br />
                <Link className={styles.link} to="mailto:tech+js@bidpro.com">
                  JetSuite
                </Link>
                <br />
                <Link className={styles.link} to="mailto:tech+ups@bidpro.com">
                  UPS
                </Link>
                <br />
                <Link className={styles.link} to="mailto:tech@bidpro.com">
                  Other
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactBox;
